import { Badge } from "@/components/ui/baseUi/badge"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import type { SessionBlockCoachNoteEntity } from "@/modules/sessions/entities/sessionBlockCoachNoteEntity"
import { word } from "@modules/core/utils/i18n"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"

type Props = {
  note: SessionBlockCoachNoteEntity
  displayDetailedEvents: boolean
  className?: string
} & React.ComponentProps<"div">

export function NoteForCoachesInEvent({ note, displayDetailedEvents, className, ...props }: Props) {
  return (
    <div className={cn("flex flex-col gap-1", className)} {...props}>
      <Text fontStyle="LS" className="text-textDefault-body uppercase">
        {word("sessionForm.blocks.note_for_coaches")}
      </Text>
      <Badge variant="primarySubtle" size="sm">
        {word(`program.note.noteType.${note.noteType}`)}
      </Badge>
      <HURichTextView
        value={formatTextToRichText(note.note)}
        paragrapheFontStyle="BS"
        numberOfLine={displayDetailedEvents ? undefined : 3}
        className="italic"
      />
    </div>
  )
}
